import ArticleContainer from './Sections/ArticleContainer'
import './style.scss'

export default function Blog({ articles }) {
  return (
    <div className="blog">
      {articles.map((article) => (
        <ArticleContainer key={article.id ?? article.slug} {...article} />
      ))}
    </div>
  )
}